<form [formGroup]="form">
  <div class="columns">
    <div class="column is-6">
      <app-input-field
        [form]="form"
        [disabled]="formDisabled"
        type="text"
        [patternKey]="'[0-9]'"
        [maxLength]="6"
        inputName="username"
        label="{{ 'booking-credentials.username' | translate }}"
        placeholder="{{ 'booking-credentials.username' | translate }}"
      ></app-input-field>
    </div>
    <div class="column">
      <app-input-field
        [form]="form"
        [disabled]="formDisabled"
        [buttonPreview]="true"
        [patternKey]="'[A-Za-z0-9]'"
        dynamicType="password"
        maxLength="8"
        inputName="password"
        label="{{ 'booking-credentials.password' | translate }}"
        placeholder="{{ 'booking-credentials.password' | translate }}"
      ></app-input-field>
    </div>
  </div>
  <div class="columns">
    <div class="column">
      <app-input-field
        [form]="form"
        [disabled]="formDisabled"
        [buttonPreview]="false"
        [maxLength]="3"
        dynamicType="sine"
        inputName="sine"
        label="{{ 'booking-credentials.sine' | translate }}"
        placeholder="{{ 'booking-credentials.sine' | translate }}"
      ></app-input-field>
    </div>
    <div class="column">
      <app-input-field
        [form]="form"
        [disabled]="true"
        [buttonPreview]="false"
        [maxLength]="1"
        dynamicType="dutyCode"
        inputName="dutyCode"
        label="{{ 'booking-credentials.dutycode' | translate }}"
        placeholder="{{ 'booking-credentials.dutycode' | translate }}"
      ></app-input-field>
    </div>
  </div>
  <div class="columns">
    <div class="column is-6">
      <app-input-select
        size="medium"
        [form]="form"
        (changeOption)="changeAction()"
        inputName="office"
        [values]="listOfOficces"
        [value]="office"
        [translate]="false"
        [id]="'office_' + index"
        label="{{ 'booking-credentials.office' | translate }}"
        placeholder="{{ 'itinerary-actions.placeholder' | translate }}"
      ></app-input-select>
    </div>
    <div class="column">
      <app-input-select
        size="medium"
        [form]="form"
        (changeOption)="changeActionStation()"
        inputName="station"
        [values]="listOfStations"
        [value]="station"
        [translate]="false"
        [id]="'station_' + index"
        label="{{ 'booking-credentials.stationNumber' | translate }}"
        placeholder="{{ 'itinerary-actions.placeholder' | translate }}"
      ></app-input-select>
    </div>
  </div>
</form>
